export default __webpack_public_path__ + "static/media/Bilanesa.ebc6e7eb.ttf";